import { z } from 'zod';
/**
 * Контракты эндпоинтов `modules/auth/tokens` — Personal Access Tokens
 * (PAT). Используются для неинтерактивного доступа к API (MCP-сервер,
 * скрипты, CI). См. `docs/modules/auth.md §7`.
 */
// ─── Метаданные токена (без секрета) ─────────────────────────────────────
//
// То, что отдаётся в списке и при создании. Сам токен (`token`) виден
// ТОЛЬКО один раз — в ответе на POST — и нигде больше не хранится в
// открытом виде.
export const ApiTokenSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    // Открытый префикс для визуального опознания: `lens_pat_ab12cd`.
    prefix: z.string(),
    lastUsedAt: z.string().nullable(),
    expiresAt: z.string().nullable(),
    createdAt: z.string(),
});
// ─── GET /api/auth/tokens ────────────────────────────────────────────────
export const ApiTokenListResponseSchema = z.object({
    tokens: z.array(ApiTokenSchema),
});
// ─── POST /api/auth/tokens ───────────────────────────────────────────────
export const CreateApiTokenRequestSchema = z.object({
    name: z.string().trim().min(1, { message: 'Укажите название токена' }).max(120),
    // Срок жизни в днях. null/отсутствует — бессрочный.
    expiresInDays: z.number().int().positive().max(3650).nullish(),
});
// Ответ на создание: метаданные + сам токен (показывается один раз).
export const CreateApiTokenResponseSchema = z.object({
    token: ApiTokenSchema,
    // Полный секрет `lens_pat_...`. Сохраните его — повторно показан не будет.
    secret: z.string().min(1),
});
